import React, { useState, useEffect } from 'react';

// Number of gallery images (update this if you add more gallery_p#.jpg files)
const GALLERY_COUNT = 6;

// Shuffle array function (Fisher-Yates algorithm)
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Dynamically generate gallery images array
const generateGalleryImages = () => {
  const images = [];
  for (let i = 1; i <= GALLERY_COUNT; i++) {
    images.push({
      src: `${process.env.PUBLIC_URL}/gallery/gallery_p${i}.jpg`,
      alt: `Gallery Image ${i}`,
      fallback: `${process.env.PUBLIC_URL}/promoBanner.png`
    });
  }
  // Randomize the order
  return shuffleArray(images);
};

const GALLERY_IMAGES = generateGalleryImages();

const HIGHLIGHTS = [
  'One-on-one, detail-oriented service',
  'A quiet, curated boutique environment',
  'Thoughtful consultation and honest professional advice',
  'Healthy, natural-looking results that last'
];

const PromoBanner = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % GALLERY_IMAGES.length);
    }, 2000);
    return () => clearInterval(timer);
  }, []);


  return (
    <section className="promo-banner" id="home">
      <div className="container promo-container">
        <div className="promo-left">
          <p className="promo-brand">JW SALON</p>
          <p className="promo-tagline">Boutique Hair Studio</p>
          <h1 className="promo-headline">Welcome to JW Salon</h1>
          <p className="promo-intro">
            A boutique-style studio led by a stylist with 20+ years of professional experience. 
            We specialize in personalized haircuts, modern color, balayage, texture waves, and deep repair treatments — all tailored to your unique style.
          </p>
          <p className="promo-intro">
            At JW Salon, we believe beauty should be clean and gentle. That's why we use organic, 
            non-toxic haircare products to protect both your hair and scalp.
          </p>
          <p className="promo-highlights-label">What clients love about us:</p>
          <ul className="promo-highlights">
            {HIGHLIGHTS.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p className="promo-closing">
            Whether you're looking for a fresh cut, a dimensional color, or a full transformation, 
            JW Salon is here to elevate your look with expertise and genuine care.
          </p>
          <a href="#contact" className="promo-cta">Book Your Visit</a>
        </div>
        <div className="promo-right">
          <div className="promo-gallery">
            {GALLERY_IMAGES.map((img, i) => (
              <div
                key={i}
                className={`promo-slide ${i === activeSlide ? 'active' : ''}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  onError={(e) => {
                    e.target.src = img.fallback || `https://via.placeholder.com/600x500/f5f5f5/999?text=${encodeURIComponent(img.alt)}`;
                  }}
                />
              </div>
            ))}
          </div>
          <div className="promo-dots">
            {GALLERY_IMAGES.map((_, i) => (
              <button
                key={i}
                className={`promo-dot ${i === activeSlide ? 'active' : ''}`}
                onClick={() => setActiveSlide(i)}
                aria-label={`View slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoBanner;
